import { Navigate } from "react-router-dom";
import { getSessionToken } from "../auth";

// Guard component for routes that need a valid session. The actual
// session validity (vs just "token exists") is enforced lazily by the
// first API call — if it 401s, api() clears the token and the page
// can redirect back to /login.

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = getSessionToken();
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
